import { EventAggregator } from 'aurelia-event-aggregator';
import {
	autoinject,
	bindable,
	BindingEngine,
	bindingMode,
	computedFrom,
	customElement,
	PLATFORM,
	useView,
} from 'aurelia-framework';

import { AutocompleteColumnHeader } from '~/components/field/common/autocomplete/autocomplete-react';
import { Country } from '~/components/field/common/country';
import { Field } from '~/components/field/common/field';
import { Postcode } from '~/components/field/common/postcode';
import { Suburb } from '~/components/field/common/suburb';
import { Form } from '~/components/form/form';

const States = [
	{
		state: 'NSW',
		stateDisplay: 'New South Wales',
	},
	{
		state: 'ACT',
		stateDisplay: 'Australian Capital Territory',
	},
	{
		state: 'VIC',
		stateDisplay: 'Victoria',
	},
	{
		state: 'QLD',
		stateDisplay: 'Queensland',
	},
	{
		state: 'SA',
		stateDisplay: 'South Australia',
	},
	{
		state: 'WA',
		stateDisplay: 'Western Australia',
	},
	{
		state: 'TAS',
		stateDisplay: 'Tasmania',
	},
	{
		state: 'NT',
		stateDisplay: 'Northern Territory',
	},
];

@autoinject
@customElement('a-state')
@useView(PLATFORM.moduleName('./state.html'))
export class State extends Field {
	private readonly columnHeaders: AutocompleteColumnHeader[] = [
		{
			columnName: 'stateDisplay',
			display: 'State',
		},
		{
			columnName: 'state',
			display: 'Code',
		},
	];

	private readonly itemColumnName = 'state';

	@bindable({
		defaultBindingMode: bindingMode.oneWay,
	})
	private countryField?: Country;

	@bindable({
		defaultBindingMode: bindingMode.oneWay,
	})
	private suburbField?: Suburb;

	@bindable({
		defaultBindingMode: bindingMode.oneWay,
	})
	private postcodeField?: Postcode;

	constructor(
		readonly element: Element,
		protected parentForm: Form,
		protected bindingEngine: BindingEngine,
		readonly eventAggregator: EventAggregator,
	) {
		super(Field.TYPE.STATE, element, parentForm, eventAggregator);
		this.isDisableInputMasks = true;
	}

	private readonly onSelect = (record: {
		[columnName: string]: any;
	}): void => {
		if (this.countryField && !this.countryField.value) {
			this.countryField.value = 'AU';
		}

		// NOTE: Jake: 2019-01-24 - WEBUI-1262
		// As defined in the JIRA noted above, expected behaviour is
		// that if you select a different state, that the suburb/postcode fields
		// get blanked out.
		if (this.suburbField && this.suburbField.value) {
			this.suburbField.value = '';
		}
		if (this.postcodeField && this.postcodeField.value) {
			this.postcodeField.value = '';
		}
	};

	@computedFrom('countryField.value')
	get items(): any[] {
		if (this.countryField && this.countryField.isBlankOrAustralia()) {
			return States;
		}
		return [];
	}
}
